<div mat-dialog-title>
  <h2>{{ 'patient-details.authorization-card.title' | translate }}</h2>
</div>
<form
  fxLayout="column"
  fxLayoutGap="10px"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
>
  <mat-dialog-content>
    <div *ngIf="insuranceProviderConfigurationService.configuration$ | async as configuration" fxLayout="column">
      <mmx-prior-authorization-form
        *ngIf="configuration"
        formControlName="priorAuthorization"
        [configuration]="configuration"
        [data]="formData"
      ></mmx-prior-authorization-form>

      <div class="loading-form" *ngIf="insuranceProviderConfigurationService.isLoading$ | async">
        {{ 'dialog.pull-pre-auth.configuration-loading' | translate }}
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button type="button" mat-dialog-close>
      {{ 'common.cancel' | translate }}
    </button>

    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="submitInProgress"
    >
      {{ 'common.submit' | translate }}
    </button>
  </mat-dialog-actions>
</form>
